import React, { ReactElement } from "react";

import { BaseStyles, ThemeProvider as FuegokitThemeProvider } from "@fuegokit/react";
import { ColorModeWithAuto } from "@fuegokit/react/lib/components/ThemeProvider/ThemeProvider";

import "@fuegokit/tokens/dist/css/atlassian/colors/light.css";
import "@fuegokit/tokens/dist/css/atlassian/colors/dark.css";

import { useNewJiraUiBackground } from "../hooks/useNewJiraUiBackground";
import { useThemeObserver } from "../hooks/useThemeObserver";

const colorModes: Record<string, ColorModeWithAuto> = {
  light: "day",
  dark: "night",
  auto: "auto",
};

export function ThemeProvider({ children }: Readonly<{ children: ReactElement }>) {
  const colorMode = useThemeObserver();
  // Remove it once Fuegokit, or Atlaskit has tokens compatible with new Jira UI
  useNewJiraUiBackground(colorMode);

  return (
    <FuegokitThemeProvider colorMode={colorModes[colorMode ?? "light"]}>
      <BaseStyles />
      {children}
    </FuegokitThemeProvider>
  );
}
